/**
 * heading-diacritic-fix.js
 *
 * Fix for clipped diacritics (Ä Ö Ü) on uppercase headings caused by the
 * theme's split-lines heading-apparition animation.
 *
 * Background:
 * theme.js (compiled, function getHeadingKeyframe) sets
 *   line.style.clipPath = "inset(0 0 -0.3em 0)"
 * on each <split-lines> line span when the heading enters the viewport.
 * The top inset of 0 means the clip starts at the line-box top — which
 * cuts off the dots above Ä/Ö/Ü when text is uppercased.
 *
 * The split-lines spans live inside Shadow DOM (open mode), so external
 * CSS cannot reach them. Direct DOM manipulation is the only option.
 *
 * Strategy:
 * Periodically rewrite any clipPath that starts with "inset(0 …)" to
 * "inset(-0.2em …)" on every split-lines line span. We poll for a few
 * seconds after page load to catch headings whose clipPath is set later
 * (when they scroll into view). This is loaded only when the theme has
 * heading_text_transform == 'uppercase' set, so non-uppercase shops pay
 * zero cost.
 */
(function () {
  'use strict';

  if (!('clipPath' in document.body.style) && !('webkitClipPath' in document.body.style)) {
    return;
  }

  function fixSplitLines() {
    var nodes = document.querySelectorAll('split-lines');
    for (var i = 0; i < nodes.length; i++) {
      var sl = nodes[i];
      if (!sl.shadowRoot) continue;
      var children = sl.shadowRoot.children;
      for (var j = 0; j < children.length; j++) {
        var line = children[j];
        if (line.nodeType !== 1) continue;
        var cp = line.style.clipPath || line.style.webkitClipPath || '';
        // Only rewrite "inset(0 …)" — leave other clip-paths alone.
        if (/^\s*inset\(\s*0(?:px)?(?=[\s,])/.test(cp)) {
          var newCp = cp.replace(/^\s*inset\(\s*0(?:px)?(?=[\s,])/, 'inset(-0.2em');
          line.style.clipPath = newCp;
          line.style.webkitClipPath = newCp;
        }
      }
    }
  }

  function start() {
    fixSplitLines();
    var attempts = 0;
    var id = setInterval(function () {
      fixSplitLines();
      if (++attempts >= 30) clearInterval(id); // ~6s of polling
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
